import { MIN_PASSWORD_LENGTH } from '@griply/utils';
import * as yup from 'yup';

export type SignupData = {
  name: string;
  email: string;
  password: string;
};

export const validationSchema: yup.ObjectSchema<SignupData> = yup.object({
  name: yup.string().required(),
  email: yup.string().email().required(),
  password: yup.string().required().min(MIN_PASSWORD_LENGTH),
});

export type SignupFormFields = yup.InferType<typeof validationSchema>;
